import PropTypes from 'prop-types';
import AnimatedIcon from './AnimatedIcon.jsx';

const MetricCard = ({ label, value, description, icon }) => {
  return (
    <div className="metric-card">
      <span className="metric-icon" aria-hidden="true">
        <AnimatedIcon name={icon} />
      </span>
      <div className="metric-value">{value}</div>
      <p className="metric-label">{label}</p>
      <p className="metric-description">{description}<sup>
              <a
                href="https://moldstud.com/articles/p-enhancing-customer-experiences-with-iot-in-the-enterprise"
                target="_blank"
                rel="noreferrer"
              >
                [source]
              </a>
            </sup></p>
    </div>
  );
};

MetricCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default MetricCard;
